<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
  >
    <template v-slot:header="{ ok, cancel }">
      <v-card-title class="screen-title">IPsec回線情報</v-card-title>
      <button
        type="button"
        aria-label="Close"
        class="close"
        @click="isChanged ? ok() : cancel()"
      >
        ×
      </button>
    </template>
    <template v-slot:body="{ ok, cancel }">
      <!-- BODY -->
      <v-card-text class="pa-0">
        <div class="modal-body">
          <div>
            <v-container>
              <v-row>
                <v-col class="d-flex flex-row ga-2 justify-end">
                  <v-btn
                    v-permission.config
                    color="primary"
                    @click="modifyIpSec"
                    >変更</v-btn
                  >
                  <v-btn
                    v-permission.config
                    color="primary"
                    @click="deleteIpSec"
                    >削除</v-btn
                  >
                </v-col>
              </v-row>

              <v-row class="mt-2">
                <!-- IPsec回線情報 -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>IPsec回線情報</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="IPsec回線番号"
                          :value="localIpSecLine.xnumber"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="IPsec回線名"
                          :value="localIpSecLine.ipsecLineName"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="USER-FQDN"
                          :value="`${localIpSecLine.userAccount}@${localIpSecLine.gw.suffix}`"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="事前共有鍵"
                          :value="localIpSecLine.preSharedKey"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="疎通試験用IPアドレス"
                          :value="localIpSecLine.connectTestIpAddress"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group label="LANアドレス">
                          <template #value>
                            <div v-if="sortedLanIpAddressList.length > 0">
                              <div class="d-flex">
                                <div class="pa-0">
                                  <p
                                    class="m-0 ml-3"
                                    v-for="i in 25"
                                    :key="i - 1"
                                  >
                                    <template
                                      v-if="sortedLanIpAddressList[i - 1]"
                                    >
                                      {{
                                        sortedLanIpAddressList[i - 1].ipAddress
                                      }}
                                    </template>
                                  </p>
                                </div>
                                <div class="pa-0">
                                  <p
                                    class="m-0 ml-3"
                                    v-for="i in 25"
                                    :key="i + 24"
                                  >
                                    <template
                                      v-if="sortedLanIpAddressList[i + 24]"
                                    >
                                      {{
                                        sortedLanIpAddressList[i + 24].ipAddress
                                      }}
                                    </template>
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div class="ml-3" v-else>-</div>
                          </template>
                        </app-label-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="備考"
                          :value="
                            $filter.emptyTo(localIpSecLine.description, '-')
                          "
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
                <!-- IPsecGW回線情報 -->
                <v-col cols="6">
                  <v-row>
                    <v-col>
                      <h3>IPsecGW回線情報</h3>
                    </v-col>
                  </v-row>
                  <div class="ml-2">
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="IPsecGW回線番号"
                          :value="localIpSecLine.gw.enumber"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="サフィックス"
                          :value="localIpSecLine.gw.suffix"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="WANアドレス"
                          :value="localIpSecLine.gw.wanAddress"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="IPsecGWアドレス"
                          :value="localIpSecLine.gw.ipsecGatewayAddress"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="管理用アドレス①"
                          :value="localIpSecLine.gw.manageAddress1"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="管理用アドレス②"
                          :value="localIpSecLine.gw.manageAddress2"
                        />
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <app-label-group
                          label="管理用アドレス③"
                          :value="localIpSecLine.gw.manageAddress3"
                        />
                      </v-col>
                    </v-row>
                  </div>
                </v-col>
              </v-row>
              <v-row class="mt-6">
                <v-col>
                  <v-tabs
                    v-model="tabValue"
                    @update:modelValue="alertClear"
                    hide-slider
                    class="border-s-sm border-t-sm border-e-sm"
                  >
                    <v-tab text="運用コマンド" value="operationCommand" />
                    <v-tab
                      text="トラフィック"
                      value="traffic"
                      v-if="contractSummary.isTrafficInfo"
                    />
                    <v-tab text="設定上限値" value="upperLimit" />
                  </v-tabs>
                  <v-tabs-window
                    v-model="tabValue"
                    class="border-s-sm border-b-sm border-e-sm"
                  >
                    <v-tabs-window-item value="operationCommand">
                      <operation-command
                        ref="operationCommand"
                        lineCategory="AC"
                        :xnumber="localIpSecLine.xnumber"
                        :ifStatus="localIpSecLine.ifStatus"
                        :keyId="localKeyId"
                        @executed="executed"
                      ></operation-command>
                    </v-tabs-window-item>
                    <v-tabs-window-item
                      value="traffic"
                      v-if="contractSummary.isTrafficInfo"
                    >
                      <traffic
                        line-type="ACCESS"
                        :line="{ enumberMainAct: localIpSecLine.enumber }"
                      />
                    </v-tabs-window-item>
                    <v-tabs-window-item value="upperLimit">
                      <upper-limit
                        upperLimitManageUnit="ACCESS"
                        :enumber="localIpSecLine.enumber"
                      />
                    </v-tabs-window-item>
                  </v-tabs-window>
                </v-col>
              </v-row>
            </v-container>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <!-- FOOTER -->
      <v-card-actions>
        <v-list-item class="w-100 pa-1">
          <template v-slot:append>
            <v-btn
              @click="isChanged ? ok() : cancel()"
              variant="outlined"
              color="primary"
              >戻る</v-btn
            >
          </template>
        </v-list-item>
      </v-card-actions>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import IpSecLineViewCD from "@/modals/ipSecLine/IpSecLineViewCD.vue";
import type { IpSecLineWithGW } from "@/views/nwSetting/ipSecLine/IpSecLineList.vue";
import IpSecLineEdit from "@/modals/ipSecLine/IpSecLineEdit.vue";
import Traffic from "@/components/operation-tool/Traffic.vue";
import OperationCommand from "@/components/operation-tool/OperationCommand.vue";
import UpperLimit from "@/components/operation-tool/UpperLimit.vue";
import { mapState } from "vuex";
import type { IpSecLineListEntity } from "@/apis/IpSecLineApi";
import sortCompare from "@/services/SortService";

export default defineComponent({
  name: "IpSecLineReference",
  components: { OperationCommand, Traffic, UpperLimit },
  props: {
    /** IPsec回線 + IPsecGW */
    ipSecLine: {
      type: Object as PropType<IpSecLineWithGW>,
      required: true,
    },
    /** IPsec回線排他情報 */
    keyId: {
      type: String as PropType<string>,
      required: true,
    },
  },
  data() {
    return {
      tabValue: "operationCommand" as
        | "operationCommand"
        | "traffic"
        | "upperLimit",
      localIpSecLine: this.ipSecLine,
      localKeyId: this.keyId,
      isChanged: false,
    };
  },
  computed: {
    ...mapState("user", {
      contractSummary: "contractSummary",
    }),
    sortedLanIpAddressList(): typeof this.localIpSecLine.lanIpAddressList {
      // IPアドレス文字列で昇順ソート
      return [...this.localIpSecLine.lanIpAddressList].sort((a, b) =>
        sortCompare(a, b, [["ipAddress", "asc"]])
      );
    },
  },
  methods: {
    // IPsec回線情報変更
    async modifyIpSec() {
      await this.alertClear();
      await this.$modal.show(IpSecLineEdit, {
        ipSecLine: this.localIpSecLine,
        acLineKeyId: this.localKeyId,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    // IPsec回線削除
    async deleteIpSec() {
      await this.alertClear();
      const note: string | null = await this.$modal.show(IpSecLineViewCD, {
        mode: "delete",
        lines: [this.localIpSecLine],
      });
      await this.$api.ipSecLine.delete({
        ipsecList: [this.localIpSecLine.xnumber],
        acLineKeyId: this.localKeyId,
        note: note,
      });
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },

    /**
     * コマンド実行後の処理
     * IF設定反映の場合、一覧画面へ戻る
     * @param eventType 実行されたコマンドの種類
     */
    async executed(eventType: string) {
      if (eventType === "IF_STATE") {
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      } else {
        this.isChanged = true;
        // 排他キーやifStatusを更新するために一覧を取得
        const latestIpsecLine = await this.$api.ipSecLine.getAll();
        const latestIpsec = latestIpsecLine.ipsecList.find(
          (e: IpSecLineListEntity) => e.xnumber === this.localIpSecLine.xnumber
        )!;
        this.localIpSecLine = {
          ...latestIpsec,
          gw: this.localIpSecLine.gw,
        };
        this.localKeyId = latestIpsecLine.acLineKeyId;
      }
    },
    /** エラーメッセージを初期化する */
    async alertClear() {
      await (
        this.$refs.operationCommand as InstanceType<typeof OperationCommand>
      ).alertClear();
    },
  },
});
</script>
